import { styled } from "@mui/material/styles";
import TooltipMUI, { tooltipClasses } from "@mui/material/Tooltip";
import React from "react";

export const Tooltip = styled(({ className, children, ...props }) => (
  <TooltipMUI {...props} arrow classes={{ popper: className }}>
    {children}
  </TooltipMUI>
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#313a51",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#313a51",
  },
});
